import { useQuery } from '@tanstack/react-query'
import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import type { T_CategoriesResponse } from '@/types/responses'

export const useCategories = () => {
  const { data, isLoading } = useQuery<T_CategoriesResponse>({
    queryKey: [ rqKeys.categories ],
    queryFn: () =>
      apiRequestNew(
        'GET',
        '/portal/article?path=information/docs&fields=name,title,description,children'
      ),
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })

  return { data, isLoading }
}
